import { first, last } from "lodash";
import { ResultSetElementType } from "store/rs-workspace/rs-workspace.types";
import { defaultYAxisConfig } from "../GraphElementGraph/utils";
import * as colors from "styles/colorValues.module.scss";
const getBarMaxWidth = (graphResult) => {
    if (!graphResult?.points) {
        return 1;
    }
    const COEFFICIENT_OF_MAGIC = 1 + 1 / graphResult.points?.length;
    const max = last(graphResult.points)?.point?.x ?? 0;
    const min = first(graphResult.points)?.point?.x ?? 0;
    return ((max - min) / graphResult.points?.length) * COEFFICIENT_OF_MAGIC;
};
export const prepareErrorsGraphPlotLayout = (graphResult, elementType, totalRunsCount) => {
    const barMaxWidth = elementType === ResultSetElementType.LineGraph ? getBarMaxWidth(graphResult) : 1;
    const shapes = elementType === ResultSetElementType.LineGraph
        ? graphResult?.points?.map(({ point, errorCount }) => {
            const failedRunsPercentage = Math.round((errorCount / totalRunsCount) * 100);
            return {
                type: "rect",
                x0: point?.x - barMaxWidth / 2,
                y0: failedRunsPercentage - 0.6,
                x1: point?.x + barMaxWidth / 2,
                y1: failedRunsPercentage,
                yref: "y2",
                fillcolor: colors.red,
                line: {
                    width: 0,
                },
            };
        })
        : [];
    return {
        yaxis2: {
            ...defaultYAxisConfig,
            side: "right",
            overlaying: "y",
            linecolor: colors.red,
            tickcolor: colors.red,
            tickfont: {
                color: colors.red,
            },
            showgrid: false,
        },
        bargap: 0,
        shapes,
        dragmode: false,
    };
};
